import Training from '../types/Training';

interface InitialTrainingState {
  trainings: Training[];
}

const initialTrainingState: InitialTrainingState = {
  trainings: [] as Training[]
};

export default initialTrainingState;